import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=b218e27e&scoped=true&"
import script from "./ContractInfo.vue?vue&type=script&lang=js&"
export * from "./ContractInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=b218e27e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b218e27e",
  null
  
)

export default component.exports